import {Component, HostListener, OnInit} from '@angular/core';
import {TranslateService} from '@ngx-translate/core';
import {EventTrackingService} from './services/event-tracking.service';
import {environment} from "../environments/environment";
import {START_MODE} from "./app.constants";
import {TokenStorageService} from "./services/token-storage.service";

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent implements OnInit {
  title = 'dashboard-mobilite';
  constructor(
    private translate: TranslateService,
    private tokenStorageService: TokenStorageService,
    private eventTrackingService: EventTrackingService
    ) {
    // Récupère la langue du système/navigateur
    const systemLanguage: string = navigator.language || (navigator as any).userLanguage;

    console.log("Langue du système :", systemLanguage);

// Exemple : "fr-FR", "en-US", "de-DE", etc.

// Si tu veux uniquement le code court (ex: "fr", "en", "de")
    const shortLang = systemLanguage.split("-")[0];
    console.log("Langue courte :", shortLang);
    translate.setDefaultLang('fr');
  }

  ngOnInit(): void {

    if (environment.startMode === START_MODE.DEV) {
      this.tokenStorageService.saveTenantID(environment.tenantID);
    }
  }
  // @HostListener('document:click', ['$event'])
  // handleClick(event: MouseEvent): any {
  //   // this.eventTrackingService.logEvent('click', {
  //   //   x: event.clientX,
  //   //   y: event.clientY,
  //   //   target: event.target
  //   // });
  //   this.eventTrackingService.logEvent('mousemove', {
  //     x: event.clientX,
  //     y: event.clientY,
  //     target: event.target
  //   });
  // }

}
